import { Component, Input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { analytics } from '@app/events/segment/analytics';

@Component({
  selector: 'app-match-score',
  imports: [
    MatTooltipModule,
  ],
  templateUrl: './match-score.component.html',
  styleUrl: './match-score.component.css'
})
export class MatchScoreComponent {
  @Input() matchScore: string = 'h1_plus';

  public readonly matchScoreTooltip = `
    Your match quality score shows how highly this career ranks compared to
    other career options — based on your interests, skills, experiences and
    real-world career data.
  `

  get displayScore(): string {
    switch (this.matchScore) {
      case 'h1_plus':
        return 'HI+';
      case 'h1':
        return 'HI';
      case 'med':
        return 'MED';
      case 'low':
        return 'LOW';
      default:
        return 'HI+';
    }
  }

  onInfoHover() {
    analytics.track('Match Info Open', { section: 'explore' });
  }
}
